module.exports = __webpack_public_path__ + "img/sp-step-5.08522371.jpg";